module.exports = __webpack_public_path__ + "static/lying-ebceef6db3b9014c327c68b31310d160.jpg";